import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';
import buildPath from '@/tsClient/utilities/buildPath';

const PATH_TEMPLATE = '/workflows/user-workflows/{userWorkflowId}/compiled-documents/apply-district-separate-uploads';
type THIS_API = ApiDefinition[typeof PATH_TEMPLATE]['POST'];
type Input = THIS_API['params'] & Partial<THIS_API['query']>;
type Output = THIS_API['response'];

const applyDistrictSeparateUploadsToPacerList = async ({ userWorkflowId, chapter, joint }: Input): Promise<Output> => {
  const path = buildPath<THIS_API>(PATH_TEMPLATE, { userWorkflowId });
  const response = await noodleApiClient.post<Output>(path, undefined, { params: { chapter, joint } });
  return response.data;
};

export default applyDistrictSeparateUploadsToPacerList;
